import {parse} from 'iso8601-duration';
import { applySpec, prop, compose } from 'ramda';

const FreeTrialEligibility = applySpec({
  isEligible: prop('is_eligible'),
  freeTrialDuration: compose(prop('days'), parse, prop('free_trial_duration')),
});

export { FreeTrialEligibility };
